const state = {
  flag: 'uz',
  objeto: {
    name: 'Nome',
    email: 'Email'
  }
}

const mutations = {
  updateUserAtual (state, res) {
    state.objeto = res.data
  }
}

// Update User
const actions = {
  updateUser (context, data) {
    var id = data.id
    let qs = require('querystring')
    var dados = qs.stringify(data.turno)
    return window.axios.put('/api/v2/turnos/' + id, dados).then((res) => {
      return res
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Users.js